export async function getHtmlPage(fileName) {
  const response = await fetch(`${process.env.PUBLIC_URL}/html-pages/${fileName}`);
  if (!response.ok) {
    return "";
  }
  return response.text();
}
